import cx from 'classnames'
import { MouseEventHandler, ReactNode } from 'react'
import { Play } from 'icons/Play'

interface Props {
  color: 'white' | 'blue' | 'magenta' | 'red'
  children: ReactNode
  onClick: MouseEventHandler<HTMLButtonElement>
  className?: string
}

export function WatchDemoButton(_props: Props) {
  return null
}

export function EnabledWatchDemoButton({
  color,
  children,
  onClick,
  className,
}: Props): JSX.Element {
  return (
    <button
      className={cx(
        'items-center inline-flex transition-colors rounded-full focus:outline-blue',
        color === 'white' && 'text-white',
        color === 'blue' && 'text-blue hover:text-blue-110 focus:text-blue-110',
        color === 'magenta' &&
          'text-magenta hover:text-magenta-110 focus:text-magenta-110',
        color === 'red' && 'text-red hover:text-red-110 focus:text-red-110',
        className && className,
      )}
      onClick={onClick}
    >
      <Play fill='currentColor' className='mr-4' />
      <span className='font-demibold pr-4'>{children}</span>
    </button>
  )
}
